import notice from "../../../../utils/notice";
import {
  getMultipartParams,
  handleResponse,
} from "../../../../crud/helpers/validate";
import { STUDENTS_URL_V2 } from "../../../../crud/helpers/routes";

export const useStudent = () => {
  //TODO pendiente para migrar funcionalidad
  //   const deleteStudent = async ({ ids }) => {
  //     try {
  //       const res = await fetch(
  //         `${STUDENTS_URL}/delete?id=${id}`,
  //         getMultipartParams("DELETE")
  //       );
  //       const json = await handleResponse(res);
  //       notice("Athlete deleted", "success");
  //       //TODO Retornar respuesta
  //     } catch (error) {
  //       notice("Error deleting the Athlete");
  //       console.log(e.errors);
  //       //TODO Pendiene definir
  //     }
  //   };
  const deleteStudentBulk = async (data) => {
    try {
      const formData = new FormData();

      for (const name in data) {
        formData.append(name, JSON.stringify(data[name]));
      }

      const res = await fetch(
        `${STUDENTS_URL_V2}/bulk_delete`,
        getMultipartParams("DELETE", formData)
      );
      const json = await handleResponse(res);

      if (json.success === false) {
        throw new Error("Bulk delete failed");
      }

      notice("Athletes deleted", "success");
    } catch (e) {
      notice("Error deleting the Athlete", "error");
      console.error(e);
      throw e;
    }
  };

  return { deleteStudentBulk };
};
